export function getAgeFromDateOfBirth(value: string) {
	if (!value.trim()) {
		return null;
	}

	const birthday = new Date(value);

	if (Number.isNaN(birthday.getTime())) {
		return null;
	}

	const today = new Date();
	let age = today.getFullYear() - birthday.getFullYear();
	const monthOffset = today.getMonth() - birthday.getMonth();

	if (
		monthOffset < 0 ||
		(monthOffset === 0 && today.getDate() < birthday.getDate())
	) {
		age -= 1;
	}

	if (age < 0 || age > 120) {
		return null;
	}

	return age;
}

export function extractFriendlyName(
	name?: string | null,
	phoneNumber?: string | null,
) {
	const trimmed = name?.trim() ?? "";

	if (!trimmed) {
		return "";
	}

	if (phoneNumber && trimmed === phoneNumber) {
		return "";
	}

	if (/^\+?\d[\d\s-]{7,}$/.test(trimmed)) {
		return "";
	}

	return trimmed;
}
